(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fruitier-luxe-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    const roots = scope.querySelectorAll ? [...scope.querySelectorAll('[data-fruitier-carousel]')] : [];
    if (scope.matches && scope.matches('[data-fruitier-carousel]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      const track = root.querySelector('[data-track]');
      const slides = [...root.querySelectorAll('[data-slide]')];
      const dots = [...root.querySelectorAll('[data-go]')];
      const previous = root.querySelector('[data-previous]');
      const next = root.querySelector('[data-next]');
      if (!track || slides.length < 2) return;
      root.dataset.initialized = 'true';
      let active = 0;
      let timer;
      let paused = false;
      const autoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const delay = Math.max(4000, Number(root.dataset.interval) || 6000);
      const paint = (index) => {
        active = (index + slides.length) % slides.length;
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          if (i === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      };
      const go = (index) => {
        const target = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        paint(target);
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (autoplay && !paused) timer = window.setInterval(() => go(active + 1), delay);
      };
      previous?.addEventListener('click', () => { go(active - 1); start(); });
      next?.addEventListener('click', () => { go(active + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { go(Number(dot.dataset.go)); start(); }));
      let scrollFrame;
      track.addEventListener('scroll', () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          if (index !== active) paint(index);
        });
      }, { passive: true });
      root.addEventListener('mouseenter', () => { paused = true; stop(); });
      root.addEventListener('mouseleave', () => { paused = false; start(); });
      root.addEventListener('focusin', () => { paused = true; stop(); });
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) { paused = false; start(); } });
      start();
    });
  };
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
